/* EvolvePLR affiliate attribution. Only an opaque link ID and expiry are stored. */
(() => {
  const KEY = 'evolveplr_affiliate_v1';
  const TTL = 90 * 24 * 60 * 60 * 1000;
  const valid = value => /^eat_[a-f0-9]{32}$/.test(value || '');
  const now = Date.now();
  let referral = null;
  try { referral = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch { /* Storage may be unavailable. */ }
  if (!referral || !valid(referral.id) || !Number.isSafeInteger(referral.expires) || referral.expires <= now || referral.expires > now + TTL) referral = null;
  const params = new URLSearchParams(location.search);
  const incoming = params.get('eatrk');
  if (valid(incoming)) referral = { id: incoming, expires: now + TTL };
  try { if (referral) localStorage.setItem(KEY, JSON.stringify(referral)); else localStorage.removeItem(KEY); } catch { /* The current visit still works. */ }

  const attributes = () => ({
    _evolve_tracking_id: referral && referral.expires > Date.now() ? referral.id : '',
    _evolve_tracking_expires: referral && referral.expires > Date.now() ? String(referral.expires) : '',
  });
  let pending;
  let saved = '';
  const sync = () => {
    const values = attributes(), signature = JSON.stringify(values);
    if (pending) return pending.then(() => saved === signature ? undefined : sync());
    if (saved === signature) return Promise.resolve();
    pending = (async () => {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: values }), signal: AbortSignal.timeout(8000),
      });
      if (!response.ok) throw new Error('We couldn’t prepare checkout. Please try again.');
      const cart = await response.json();
      if (Object.entries(values).some(([key, value]) => String(cart.attributes?.[key] || '') !== value)) throw new Error('We couldn’t prepare checkout. Please try again.');
      saved = signature;
    })().finally(() => { pending = null; });
    return pending;
  };
  // Ordinary storefront visits do not depend on affiliate tracking availability.
  window.EvolveAffiliateSync = () => referral && referral.expires > Date.now() ? sync() : Promise.resolve();

  // Cart forms submit these attributes with checkout, including drawer forms.
  const prepareForms = () => document.querySelectorAll('form[action]').forEach(form => {
    const url = new URL(form.action, location.href);
    if (url.origin !== location.origin || !/\/cart\/?$/.test(url.pathname)) return;
    for (const [key, value] of Object.entries(attributes())) {
      const name = `attributes[${key}]`;
      let field = form.querySelector(`input[name="${name}"]`);
      if (!field) { field = document.createElement('input'); field.type = 'hidden'; field.name = name; form.append(field); }
      field.value = value;
    }
  });
  document.addEventListener('submit', prepareForms, true);
  // Direct checkout links wait for the same cart write. Native cart form
  // checkout includes the hidden fields above, so no submit replay is needed.
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || !/\/checkout\/?$/.test(url.pathname)) return;
    event.preventDefault();
    window.EvolveAffiliateSync().then(() => location.assign(url.href)).catch(error => window.alert(error.message));
  }, true);
  const start = () => {
    prepareForms();
    sync().catch(() => { /* The cart action retries before adding a product. */ });
    // Custom bundle pages display several product forms. A variant link takes
    // the customer to the requested option without adding anything to the cart.
    const variant = params.get('variant');
    if (/^\d+$/.test(variant || '')) {
      const forms = [...document.querySelectorAll('form[data-evolve-ajax-form]')];
      const target = forms.find(form => form.querySelector('input[name="id"]')?.value === variant);
      if (target && forms.some(form => form.querySelector('input[name="id"]')?.value !== variant)) {
        const card = target.closest('[data-evolve-individual-option], .evolve-option-card, .evolve-price-card') || target;
        card.scrollIntoView({ block: 'center' });
        const button = target.querySelector('button');
        if (button) button.focus({ preventScroll: true });
      }
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
})();

// Load the shared landing confirmation separately from cart attribution.
(function () {
  if (document.querySelector('script[data-evolve-landing-v2]')) return;
  var script = document.createElement('script');
  script.src = 'https://evolveaffiliates.app/affiliate-visit.js';
  script.async = true;
  script.setAttribute('data-evolve-landing-v2', '');
  document.head.appendChild(script);
})();
